import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "configuredOnly", "kind", "loader", "clearSearch"]

  submit() {
    this.formElement.requestSubmit()
  }

  removeKind(event) {
    const kind = event.currentTarget.dataset.kindValue
    this.kindTargets.forEach((cb) => {
      if (cb.value === kind) cb.checked = false
    })
    this.submit()
  }

  removeConfiguredOnly() {
    if (this.hasConfiguredOnlyTarget) {
      this.configuredOnlyTarget.checked = false
    }
    this.submit()
  }

  clearAll() {
    this.kindTargets.forEach((cb) => (cb.checked = false))
    if (this.hasConfiguredOnlyTarget) {
      this.configuredOnlyTarget.checked = false
    }
    this.submit()
  }

  clearSearch() {
    // Focus before submit is intentional: the turbo_stream response replaces
    // #source_catalog_results, which lives below the search input. Focus on
    // the input survives the swap because the input is outside the replaced
    // target. If a future refactor moves the search input under the replaced
    // target, this focus call needs to move into a turbo:after-stream-render
    // listener.
    const input = this.formElement.querySelector('input[name="card_search"]')
    if (!input) return
    input.value = ""
    input.focus()
    this.submit()
  }

  showLoader() {
    if (this.hasClearSearchTarget) this.clearSearchTarget.classList.add("hidden")
    if (this.hasLoaderTarget) this.loaderTarget.classList.remove("hidden")
  }

  hideLoader() {
    if (this.hasLoaderTarget) this.loaderTarget.classList.add("hidden")
    if (this.hasClearSearchTarget) this.clearSearchTarget.classList.remove("hidden")
  }

  get formElement() {
    return this.hasFormTarget ? this.formTarget : this.element.closest("form")
  }
}
